<style lang="less" scoped>
.book-learningpre {
  background-color: @white;
  border-radius: @border-radius-base;
  height: 100%;
  width: 100%;
}
.header {
  // width: 1440px;
  height: 90px;
  background-color: white;
  display: flex;
  align-items: center;
  position: relative;
}
.reading-back {
  position: relative;
  cursor: pointer;
  left: 50px;
}
.paperheader {
  display: flex;
  align-items: center;
  position: absolute;
  left: 55%;
  transform: translateX(-50%);
  .title {
    font-family: 'STSongti-SC-Bold';
    font-size: 30px;
    color: black;
  }
  .author {
    font-size: 20px;
    font-family: 'STKaitiSC-Regular';
    color: #867d7b;
    transform: translateX(40px);
  }
}
.content {
  background-color: #f1f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
  .label {
    width: 200px;
    height: 50px;
    border-radius: @border-radius-base;
    border: 2px solid #5a99ef;
    font-size: 24px;
    color: #5a99ef;
    font-family: 'PingFangSC-Regular';
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .prepare-content,
  .task-item {
    width: 1100px;
    height: 100%;
    background-color: white;
    border-radius: @border-radius-base;
    margin-top: 30px;
    padding: 30px 50px;
    font-size: 20px;
    white-space: pre-wrap;
  }
  .start-btn {
    border: none;
    margin-top: 30px;
    width: 250px;
    height: 50px;
    font-size: 24px;
    font-family: 'PingFangSC-Regular';
    color: white;
    border-radius: 25px;
    background-color: #db5647;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    -moz-user-select: none;
    -webkit-user-select: none;
    &:hover {
      cursor: pointer;
    }
  }
  .start-btn-disable {
    opacity: 0.3;
    &:hover {
      cursor: default;
    }
  }
}
.task-logo {
  width: 17px;
  height: 20px;
}
.task-content {
  margin-top: 10px;
}
.task-content-i {
  font-size: 22px;
  font-family: 'PingFangSC-Regular';
}
.task-content-ii {
  font-size: 20px;
  color: #867d7d;
  font-family: 'PingFangSC-Regular';
  display: flex;
  align-items: center;
  margin-top: 20px;
  span {
    transform: translateX(20px);
  }
}
</style>

<template>
  <div class="book-learningpre">
    <div class="header">
      <han-icon type="leftDobuleArrowIcon" class="reading-back" @click="onBack" />
      <div class="paperheader">
        <span class="title">{{orgDisplayName}}</span>
        <span class="author">{{author}}</span>
      </div>
    </div>
    <div class="content">
      <!-- <div class="label" style="margin-top:30px;">学前准备</div> -->
      <div class="prepare-content">
        <div v-for="item in prepareData" :key="item.id">
          <p style="text-indent:2em" v-if="!!item.content&&Number(item.isMap===0)">{{item.content.trim()}}</p>
          <p v-if="!!item.detailContent">{{item.detailContent}}</p>
          <p v-if="Number(item.type)===2" style="text-align: center">
            <img style="height:80%" :src="resBasePath+item.photoCover" />
          </p>
          <ts-video v-if="Number(item.type)===3" :poster="resBasePath+item.videoPhoto"
                    :vPath="resBaseVideo+item.videoPath">
          </ts-video>
          <p v-if="Number(item.type)===4" style="text-align:center">
            <audio controls :src="resBasePath+item.audioPath" />
          </p>
          <a v-if="Number(item.type)===5" style="cursor: pointer">{{item.readStyleId}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shareState from 'utils/shareState.js';
import HanIcon from 'components/Icon.vue';
import Card from './components/card.vue';
import tsVideo from './components/tsvideo.vue';
export default {
  name: 'LearningPre',
  components: {
    Card,
    HanIcon,
    tsVideo,
  },
  created() {
    this.getPrepare();
    this.getTasks();
    this.orgDisplayName = window.localStorage.getItem('syzg-orgDisplayName');
    this.author = window.localStorage.getItem('syzg-author');
  },
  data() {
    return {
      shareData: shareState.state,
      resBasePath: this.$resBasePath,
      resBaseVideo: this.$resBaseVideo,
      prepareData: [],
      taskData: [],
      form_active: null,
      form: [],
      orgDisplayName: '',
      author: '',
      taskId: '',
    };
  },
  watch: {
    form_active(newval, oldval) {
      // 设置单选
      this.form[newval] = true;
      this.form[oldval] = false;
    },
  },
  computed: {
    submitAble: function () {
      let res = false;
      for (const i of this.form) {
        res = res || i;
      }
      return res;
    },
  },
  methods: {
    getPrepare() {
      this.$fetch({
        url: this.$baseUrl + 'ebook/study/getPrestudyPrepare',
        body: {
          styleId: this.$route.params.id,
        },
      }).done((res) => {
        this.prepareData = res.resultData;
        // console.log(res.resultData)
      });
    },
    getTasks() {
      this.$fetch({
        url: this.$baseUrl + 'ebook/study/getTask',
        body: {
          styleId: this.$route.params.id,
        },
      }).done((res) => {
        this.taskData = res.resultData;
        this.form = new Array(this.taskData.length).fill(false);
        // console.log(res.resultData)
      });
    },
    onBack() {
      this.$router.push({ path: '/books/' });
    },
    onChange(index, id) {
      this.taskId = id;
      this.form_active = index;
    },
    startToLearning() {
      if (this.submitAble && this.taskId !== '') {
        const id = this.shareData.genreType === 5 ? this.shareData.completeBookList[0].id : this.$route.params.id;
        this.$fetch({
          url: this.$baseUrl + 'ebook/study/saveTask',
          body: {
            styleId: id,
            taskId: this.taskId,
          },
        }).done((res) => {
          if (res.success) {
            this.$router.push({ path: `/books/reading-book/${id}` });
          } else {
            this.$message.error('保存任务失败！');
          }
        });
      }
    },
  },
};
</script>
